import React, { useContext, useEffect, useRef, useState } from 'react'
import styles from '../styles/sideContent.module.css'
import { IoIosArrowRoundBack } from "react-icons/io";
import UserContext from '../context/user/UserContext';
import StateContext from '../context/state/StateContext';
import { IoMdAlarm } from "react-icons/io";
import { IoFlag } from "react-icons/io5";
import { toast } from 'react-toastify';
import axios from 'axios';
import { IoMdPie } from "react-icons/io";
import { IoIosCheckmarkCircle } from "react-icons/io";
import Note from './Note';
import { FaTasks } from "react-icons/fa";
import { FaComment } from "react-icons/fa";
import { FaEye } from "react-icons/fa";
import { FaCloudDownloadAlt } from "react-icons/fa";
import { BiSolidTrashAlt } from "react-icons/bi";
import { Swiper, SwiperSlide } from 'swiper/react';
import { FaAngleRight } from "react-icons/fa";
import { FaAngleLeft } from "react-icons/fa";
import { LuCalendarClock } from "react-icons/lu";
import { AiOutlineCloudDownload } from "react-icons/ai";



// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


import { Navigation, Pagination } from 'swiper/modules';

const SideContent = ({ data, open, close }) => {

    const { setModal, setTicketIds, setTickets, confirm, setConfirm, token, detail, setDetail, delayRequest, setDelayRequest } = useContext(StateContext);
    // const data = detail.data
    const { user } = useContext(UserContext)
    // const data = detail.detail
    const [status, setStatus] = useState('');
    const [noteModal, setNoteModal] = useState(false);
    const [action, setAction] = useState('');

    const prevRef = useRef(null);
    const nextRef = useRef(null);

    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'short', day: 'numeric' };
        const date = new Date(dateString);
        return date.toLocaleDateString(undefined, options);
    };


    const getNotIcon = (status) => {
        if (status === "completed") {
            return <i className='bx bx-check' style={{ color: "green" }}></i>
        } else if (status === "in progress") {
            return <IoMdPie color='golden' />
        } else if (status === "accepted") {
            return <IoIosCheckmarkCircle color='green' />
        } else if (status === "rejected") {
            return <i className='bx bx-x' style={{ color: "red" }} ></i>
        } else if (status === "download") {
            return <AiOutlineCloudDownload />
        } else {
            return <FaComment />
        }
    }

    const handleDownload = (filename) => {
        const fileUrl = encodeURIComponent(`${process.env.REACT_APP_API_URL}uploads/${filename}`);
        const proxyUrl = `${process.env.REACT_APP_API_URL}download?url=${fileUrl}&filename=${filename}`;

        const link = document.createElement("a");
        link.href = proxyUrl;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };




    function formatString(input) {
        // Remove numbers and file extensions
        let withoutNumbersAndExtension = input.replace(/\d+|(\.\w+)$/g, '');

        // Replace hyphens with spaces
        let withSpaces = withoutNumbersAndExtension.replace(/-/g, ' ');

        // Capitalize each word
        let capitalized = withSpaces.replace(/\b\w/g, char => char.toUpperCase());

        return capitalized.trim();
    }


    // Helper: Check if the user can manage the schedule
    const canManageSchedule = (user, data) => (
        user.role === "admin" || user.id === data.generatedById
    );

    // Helper: Format the "custom" repeat text
    const formatCustomRepeat = ({ repeatUnit, repeatInterval, selectedDays, endOption, occurrences, endDate, occurenceOption, occurenceDates }) => {
        let result = `Every ${repeatInterval} ${repeatUnit}`;
        if (repeatUnit !== "days" && selectedDays) result += ` on ${selectedDays}`;
        if (endOption === "after-occurrences") result += ` till ${occurrences} times`;
        if (endOption === "on-date") result += ` till ${endDate}`;
        // Handle custom occurrence dates
        if (occurenceOption === "dates" && occurenceDates?.length > 0) {
            // Break dates into rows with 3 dates per line
            const chunkedDates = [];
            for (let i = 0; i < occurenceDates.length; i += 3) {
                chunkedDates.push(occurenceDates.slice(i, i + 3).join(" | "));
            }
            const formattedDates = chunkedDates.join("<br>");
            return `<div style="font-weight: 400;font-size: 1.1em;">${formattedDates}</div>`;
        }
        return result
    };

    // Helper: Render cancel button
    const renderCancelButton = (data, user) => (
        canManageSchedule(user, data) && (
            <button style={{ width: "fit-content" }}
                className={styles.button}
                onClick={() => handleCancelClick(data.id)}
            >
                <i style={{ color: "red" }} className="bx bxs-trash"></i>
                <span>Cancel</span>
            </button>
        )
    );

    // Cancel handler function
    const handleCancelClick = (ticketId) => {
        setModal({ open: true, component: "Confirm" });
        setConfirm({
            component: "Schedule",
            ticketId,
            text: "Are you sure you want to cancel this Schedule?",
        });
    };

    

    if (data) {
        return (
            <>
                <Note status={status} setStatus={setStatus} setAction={setAction} action={action} data={data} notes={data?.note} open={noteModal} close={setNoteModal} />
                <div className={`${styles.backDrop} ${open && detail.open ? styles.active : ''}`} onClick={() => { close(false); setDetail({ open: false, detail: "" }) }}></div>
                <div className={`${styles.sideContent} ${open && detail.open ? styles.active : ''}`}>
                    {data && <div className={styles.content}>
                        <div className={styles.back} onClick={() => { close() }}>
                            <IoIosArrowRoundBack />
                            <span>Task Details</span>
                        </div>
                        <h3>{data.title}</h3>
                        <table className={styles.table_container}>
                            <tbody>
                                <tr className='align-items-center mb-0 w-100'>
                                    <td className={styles.width}><b>Assigned By</b></td>
                                    <td className={styles.width}>
                                    <p className={`${styles.user} !bg-white !border-none !p-0`}>
                                        {data.generatedBy.picture ? <div className={styles.img}><img src={process.env.REACT_APP_API_URL + `uploads/${data.generatedBy.picture}`} className='img-fluid' alt="" /> </div> : <i className={`bx bxs-user-circle ${styles.img1}`}></i>}
                                        {data.generatedBy.username}</p>
                                    </td>
                                </tr>
                                <tr className='align-items-center mb-0 w-100'>
                                    <td className={styles.width}><b>Assigned To</b></td>
                                    <td className={`${styles.users} d-flex align-items-center flex-nowrap`} style={{ gap: "15px" }}>
                                        {data.users && data.users.map((item, index) => {
                                            return <p key={index} className={styles.user}>
                                                {item.picture ? <div className={styles.img}><img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" /></div> : <i className={`bx bxs-user-circle ${styles.img1}`}></i>}
                                                {item.username}</p>
                                        })}
                                    </td>
                                </tr>
                                {data.acknowledge.length > 0 && <tr className='align-items-center mb-0 w-100'>
                                    <td className={styles.width}><b>Acknowledge To</b></td>
                                    <td className={`${styles.users} d-flex align-items-center flex-nowrap`} style={{ gap: "15px" }}>
                                        {data.acknowledge && data.acknowledge.map((item, index) => {
                                            return <p key={index} className={styles.user}>
                                                {item.picture ? <div className={styles.img}><img src={process.env.REACT_APP_API_URL + `uploads/${item.picture}`} className='img-fluid' alt="" /></div> : <i className={`bx bxs-user-circle ${styles.img1}`}></i>}
                                                {item.username}</p>
                                        })}
                                    </td>
                                </tr>}
                                <tr>
                                    <td className={styles.width}><b>Task No.</b></td>
                                    <td><p>{data.id}</p></td>
                                </tr>
                                <tr>
                                    <td className={styles.width}><b>Category</b></td>
                                    <td><p>{data.category}</p></td>
                                </tr>
                                {data.status === "in progress" || data.status == "completed" ? <tr>
                                    <td className={styles.width}><b>Status</b></td>
                                    <td><p style={{ textTransform: "capitalize" }}>{data.status === "in progress" ? <IoMdPie color='golden' /> : <IoIosCheckmarkCircle color='green' />} {data.status}</p></td>
                                </tr> : null}
                                {data.priority && <tr>
                                    <td className={styles.width}><b>Priority</b></td>
                                    <td><p><IoFlag /> {data.priority}</p></td>
                                </tr>}
                                <tr>
                                    <td className={styles.width}><b>Created At</b></td>
                                    <td><p>{formatDate(data.created_at)}, {new Date(data.created_at).toLocaleTimeString()}</p></td>
                                </tr>
                                {data.date ? <tr>
                                    <td className={styles.width}><b>Deadline</b></td>
                                    <td className={styles.date}><IoMdAlarm /> <p>{formatDate(data.date)}, {data.time && ''}</p></td>
                                </tr> : null}
                                {data.links && data.links.length > 0 ? <tr>
                                    <td className={styles.width}><b>Links</b></td>
                                    <td>
                                        <p className={`flex-column align-items-start`} style={{ gap: "2px"}}>
                                            {data && data.links.map((item, index) => {
                                                return <a key={index} target="_blank" href={item} className='text-decoration-underline' style={{overflow: "hidden", maxWidth: "100%" }}><span>{item.slice(0, 50)}{item.length > 50 && "..."}</span></a>
                                            })}</p>
                                    </td>
                                </tr> : null}
                                {data.uploads && data.uploads.length > 0 ? <tr>
                                    <td className={styles.width}>Uploads</td>
                                    <td className={styles.images}>
                                        <Swiper
                                            navigation={{
                                                prevEl: prevRef.current,
                                                nextEl: nextRef.current,
                                            }}
                                            pagination={{ clickable: true }} // Enable pagination dots
                                            slidesPerView={1} modules={[Navigation, Pagination]} style={{ width: "100%" }} className="mySwiper d-flex align-items-center"
                                        >
                                            {data.uploads.map((item, index) => {
                                                // Determine the file URL
                                                const fileUrl = `${process.env.REACT_APP_API_URL}uploads/${item.name}`;

                                                // Check if the file is an image based on its extension
                                                const isImage = /\.(jpg|jpeg|png|gif)$/i.test(item.name);

                                                // Return Swiper slides based on whether the file is an image or not
                                                return (
                                                    <SwiperSlide key={index}>
                                                        <div className={styles.uploadItem}>
                                                            <div className={styles.uploadContent}>
                                                                {isImage ? (
                                                                    <img src={fileUrl} className='img-fluid' alt={item.name} />
                                                                ) : (
                                                                    <div className={`d-flex flex-column ${styles.pdf}`}>
                                                                        <span className='text-center text-wrap' style={{ overflowWrap: 'anywhere' }}>
                                                                            {item.name}
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                            <div className={styles.menuDrop}></div>
                                                            <div className={styles.menu}>
                                                                <div className={styles.menuContent}>
                                                                    <a href={fileUrl} target='_blank'>
                                                                        <FaEye className={styles.icon} />
                                                                    </a>
                                                                    <a href={fileUrl} download={item.name} target='_blank' rel='noopener noreferrer'>
                                                                        <FaCloudDownloadAlt style={{ backgroundColor: 'RoyalBlue' }} className={styles.icon} />
                                                                    </a>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </SwiperSlide>
                                                );
                                            })}
                                        </Swiper>
                                        <div className={styles.customNavigation}>
                                            <button ref={prevRef} className={styles.prevButton}>
                                                <FaAngleLeft />
                                            </button>
                                            <button ref={nextRef} className={styles.nextButton}>
                                                <FaAngleRight /> {/* Example right arrow icon */}
                                            </button>
                                        </div>
                                    </td>
                                </tr> : null}
                                {data.audio ? <tr>
                                    <td className={styles.width}><b>Audio</b></td>
                                    <td>
                                    <audio controls>
                                        <source src={process.env.REACT_APP_API_URL + `uploads/${data.audio.name}`} type="audio/mpeg" />
                                        Your browser does not support the audio element.
                                    </audio>
                                    </td>
                                </tr> : null}
                                {
                                    data.repeat !== "does_not_repeat" && canManageSchedule(user, data) && (
                                        <tr>
                                            <td className={styles.width}><b>Schedule</b></td>
                                            <td className='row'>
                                                {data.repeat === "custom"
                                                    ? <div
                                                        dangerouslySetInnerHTML={{
                                                            __html: formatCustomRepeat(data.repeat_data)
                                                        }}
                                                    />
                                                    : data.repeat}
                                                {renderCancelButton(data, user)}
                                            </td>
                                        </tr>
                                    )
                                }
                                <tr>
                                    <td className={styles.width}><b>Description</b></td>
                                    <td className={styles.para}><p className='text-wrap'>{data.description}</p></td>
                                </tr>
                                <tr>
                                    <td className={styles.width}><b>Last Updated</b></td>
                                    <td><p>{formatDate(data.updated_at)}, {new Date(data.updated_at).toLocaleTimeString()}</p></td>
                                </tr>
                            </tbody>
                        </table>

                        <div className="d-flex justify-content-start align-items-start flex-wrap w-100 mt-1" style={{ gap: "10px" }}>

                            {/* button for in progress status */}
                            {data.employeeId.includes(user.id) && data.status !== "in progress" && data.status !== "completed" && (
                                <button
                                    onClick={() => {
                                        setStatus("in progress");
                                        setNoteModal(true);
                                    }}
                                    className={styles.button}
                                >
                                    <IoMdPie color="golden" />
                                    <span>In Progress</span>
                                </button>
                            )}

                            {/* button for completed status */}
                            {data.employeeId.includes(user.id) && data.status !== "completed" && (
                                <button
                                    onClick={() => {
                                        setStatus("completed");
                                        setNoteModal(true);
                                    }}
                                    className={styles.button}
                                >
                                    <i className="bx bx-check" style={{ color: "green" }}></i>
                                    <span>Completed</span>
                                </button>
                            )}

                            {/* button for Delete and edit Ticket */}
                            {(user.role === "admin" || user.id === data.generatedById) && data.status !== "completed" && (
                                <>
                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setModal({ open: true, component: "Confirm" });
                                            setConfirm({
                                                component: "Ticket",
                                                ticketId: data.id,
                                                text: "Are you sure you want to delete this Ticket?",
                                            });
                                        }}
                                    >
                                        <i style={{ color: "red" }} className="bx bxs-trash"></i>
                                        <span>Delete</span>
                                    </button>

                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setModal({ open: true, component: "Update" });
                                            setTicketIds({
                                                id: data.id,
                                                clientId: data.clientId,
                                                employeeId: data.employeeId,
                                            });
                                        }}
                                    >
                                        <i className="bx bx-edit-alt"></i>
                                        <span>Edit</span>
                                    </button>
                                </>
                            )}

                            {/* button for Accept and Reject status */}
                            {(user.role === "admin" || data.generatedById === user.id) && data.status === "completed" && data.submission !== "accepted" && (
                                <>
                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setNoteModal(true);
                                            setAction("accept");
                                        }}
                                    >
                                        <IoIosCheckmarkCircle color="green" />
                                        <span>Accept</span>
                                    </button>

                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setNoteModal(true);
                                            setAction("reject");
                                        }}
                                    >
                                        <i className="bx bx-x" style={{ color: "red" }}></i>
                                        <span>Reject</span>
                                    </button>
                                </>
                            )}

                            {/* button for Request for Delay */}
                            {data.employeeId.includes(user.id) && data.status !== "completed" && data.request_delay !== "requested" && (
                                <button
                                    className={styles.button}
                                    onClick={() => {
                                        setNoteModal(true);
                                        setAction("delayRequest");
                                        setDelayRequest(true);
                                    }}
                                >
                                    <LuCalendarClock color="orange" />
                                    <span>Request for Delay</span>
                                </button>
                            )}

                            {/* button for Accept and Reject Request  */}
                            {(user.role === "admin" || data.generatedById === user.id) && data.status !== "completed" && data.request_delay === "requested" && (
                                <>
                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setNoteModal(true);
                                            setAction("accepted_request");
                                            setDelayRequest(true);
                                        }}
                                    >
                                        <IoIosCheckmarkCircle color="green" />
                                        <span>Accept Request</span>
                                    </button>

                                    <button
                                        className={styles.button}
                                        onClick={() => {
                                            setNoteModal(true);
                                            setAction("rejected_request");
                                            setDelayRequest(true);
                                        }}
                                    >
                                        <i className="bx bx-x" style={{ color: "red" }}></i>
                                        <span>Reject Request</span>
                                    </button>
                                </>
                            )}
                        </div>
                        <div className={styles.updates}>
                            <div className="d-flex align-items-center justify-content-between">
                                <h5 className='d-flex align-items-center'><FaTasks className='me-2' /> Task Updates</h5>
                                <button className={`${styles.button} mt-0`} onClick={() => { setNoteModal(true); setAction("comment"); setStatus("") }}><FaComment /> <span>Add Comment</span></button>
                            </div>
                            <ul>
                                {data && data.note && data.note.length > 0 ?
                                    data.note.map((item, index) => {
                                        return <li key={index}>
                                            <h6 className={styles.user} key={index}>
                                                {item.user && item.user.picture ? <img src={process.env.REACT_APP_API_URL + `uploads/${item.user && item.user.picture}`} className='img-fluid' alt="" /> : <i className={`bx bxs-user-circle ${styles.img}`}></i>}
                                                {item.user && item.user.username}</h6>
                                            <span>{item.user && formatDate(item.updated_at)}{item.user && ` - ${new Date(item.updated_at).toLocaleTimeString()}`}</span>
                                            {item.updatedDate && <span className="ms-2">({`${item.updatedDate}`})</span>}
                                            <div className="d-flex align-items-start justify-content-between w-100">
                                                <div className="d-flex flex-column align-items-start">
                                                    <p className='text-wrap'>{item.note}</p>
                                                    <div className='mt-1 d-flex align-items-center flex-wrap'>
                                                        {item.files && item.files.length > 0 && item.files.map((item, index) => {
                                                            return <a key={index} download={item.name} onClick={() => { handleDownload(item.name) }} className={styles.button} style={{ cursor: "pointer", marginRight: "10px", marginBottom: "10px", alignSelf: "start" }} disabled={true}>{getNotIcon("download")}<span>{formatString(item.name)}</span></a>
                                                        })}
                                                        {item.audio ? <>
                                                            <div className='ms-1'>
                                                            <audio controls>
                                                                <source src={process.env.REACT_APP_API_URL + `uploads/${item.audio.name}`} type="audio/mpeg" />
                                                                Your browser does not support the audio element.
                                                            </audio>
                                                            </div></>
                                                            : null}
                                                    </div>
                                                </div>
                                                {item.action === "delayRequest" ? <><button className={styles.button} disabled={true}>{<LuCalendarClock color='red' />}<span className='text-danger'>Delay Request</span></button></> : item.action === "accepted_request" ? <><button className={styles.button} disabled={true}><IoIosCheckmarkCircle color='green' /><span>{item.status}</span></button></> : item.action === "rejected_request" ? <><button className={styles.button} disabled={true}><i className='bx bx-x' style={{ color: "red" }} ></i><span className='text-danger'>Request Rejected</span></button></> : <><button className={styles.button} disabled={true}>{getNotIcon(item.status)}<span>{item.status}</span></button></>}
                                            </div>
                                        </li>
                                    }) :
                                    <div className={styles.not_found}>
                                        <img src='/images/update_not_found.png' alt='' className='img-fluid' />
                                        <h4>No Task Updates Found</h4>
                                        <p className='mt-0'>It seems that no one has updated this task</p>
                                    </div>
                                }
                            </ul>
                        </div>
                    </div>}
                </div >
            </>
        )
    }
}

export default SideContent
